import PropTypes from 'prop-types';
import './progressBar.scss';

const ProgressBar = ({ activeStep, numberOfSteps, hasBackgroundImage }) => {
  const progressPercentage = ((activeStep + 1) / numberOfSteps) * 95 // never fill it 100%, last step should show as almost 100%
  return (
    <div className='vf-progress-bar' data-test='progress-bar'>
      <div style={{ width: `${progressPercentage}%` }} className={`progress ${hasBackgroundImage ? 'progress-wave' : ''}`} />
    </div>
  );
};

ProgressBar.propTypes = {
  activeStep: PropTypes.number.isRequired,
  numberOfSteps: PropTypes.number.isRequired,
  hasBackgroundImage: PropTypes.bool,
};

ProgressBar.defaultProps = {
  hasBackgroundImage: false,
};

export default ProgressBar;
